export const USER_ROLES = Object.freeze({
  APPLICANT: 'applicant',
  ORGANIZATION_USER: 'organizationUser',
  ORGANIZATION_ADMIN: 'organizationAdmin'
});
